import {env} from '@px/helper/env';
import {setProfile, track, pageView} from './et';
import {track as ga4Track, pageView as ga4PageView} from './ga4';

declare global {
  interface ET {
    track(eventName: string, params: any): void;
    pageView(params: any): void;
    setProfile(record: Record<string, any>): void;
  }
}

export const sd = resolveSD();

function resolveSD(): ET {
  if (env.isBrowser && !env.isBot) {
    return {
      setProfile(record: Record<string, any>) {
        setProfile(record);
      },
      track(eventName: string, params: Record<string, any>) {
        track(eventName, params);
        ga4Track(eventName, params);
      },
      pageView(params: Record<string, any>) {
        pageView(params);
        ga4PageView(params);
      },
    };
  }

  return {
    setProfile(record: Record<string, any>) {},
    track(eventName: string, params: any) {},
    pageView(params: any) {},
  };
}
